module.exports = __webpack_public_path__ + "img/romania.90044ff8.png";